// extracted by mini-css-extract-plugin
export default {"form":"_1rxfNNuDcZ3FNFpAOK00T6","label":"_3ZpSgSPI92BIgPLi5aLAWw","input":"_3-i2B8uEZYXgQaALDSYE6s","errorMessage":"n1TPHjCzAD-UNALQoAEOM","required":"_25b3KCCJ49EkBRsRky-28V"};